<div class="card-body ml-3 mr-3">
  <h4>{{ title | translate }}</h4>
  <form [formGroup]="infoForm" (ngSubmit)="onSubmit()">
    <div class="row">
      <div class="form-group col-12">
        <textarea
          class="form-control mh-400"
          id="message"
          type="text"
          formControlName="message"
          title="message"
          #text
          >
        </textarea>
      </div>

      @if (showTemplates()) {
        <div class="col-2">
          <app-template-text-list-container
            [templatesKey]="templatesKey"
            (onTemplateClick)="templateSelected($event)">
          </app-template-text-list-container>
        </div>
      }
    </div>
    <ng-content></ng-content>
    <div class="row">
      <div class="text-right col-12">
        <button class="btn mr-2" type="button" (click)="goToBack()">
          {{ 'BO_CANCEL' | translate }}
        </button>
        <button class="btn btn-primary" [disabled]="submitting" type="submit">
          {{ 'BO_SUBMIT' | translate }}
        </button>
      </div>
    </div>
  </form>
</div>
